import { createContext, useContext } from "react";
import type { IBulkExportContextValue } from "./BulkExportProvider.types";

export const BulkExportContext = createContext<IBulkExportContextValue | undefined>(undefined);

export function useBulkExportContext() {
  return useContext(BulkExportContext);
}